module.exports = __webpack_public_path__ + "img/2.38e0688d.png";